


























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { PointsListResponseData } from '@/api-v2/Points';
import AdminButton from '@/components/AdminButton.vue';
import NfcPointWriteButton from '@/mixins/NfcPointWriteButton';
import { RoutesListResponseData } from '@/api-v2/Routes';

@Component({
  components: {
    AdminButton,
  },
})
export default class TableCellName extends Mixins(NfcPointWriteButton) {
  @Prop(Object) readonly item!: PointsListResponseData;

  get routes(): RoutesListResponseData[] {
    return this.item.routes ?? [];
  }
}
